import { Command } from 'commander';
import chalk from 'chalk';
import fs from 'fs/promises';
import api from '../services/api';
import ux from '../utils/ux';
import asyncErrorWrapper from '../utils/async-error-wrapper';
import output from '../utils/output-writer';

const getAlert = new Command('get-alert')
  .description(
    'Parse a Slack or Teams alert message and return the matching book and variables'
  )
  .requiredOption(
    '-l, --alert-link <alertLink>',
    'The link to a Slack or Teams alert message to parse'
  )
  .option('-o, --output-path <outputPath>', 'File path to write the output to')
  .action(
    asyncErrorWrapper(
      async ({
        alertLink,
        outputPath,
      }: {
        alertLink: string;
        outputPath?: string;
      }) => {
        const result = await ux.runWithProcessingIndicator({
          msg: `Parsing alert ${chalk.green(alertLink)}`,
          func: async () => api.getAlert({ messageLink: alertLink }),
        });

        const resultJson = JSON.stringify(result, null, 2);
        if (outputPath) {
          await fs.writeFile(outputPath, resultJson, 'utf8');
          output.info(`Output written to ${outputPath}`);
        } else {
          output.info(resultJson);
        }
      }
    )
  );

export default getAlert;
